import { render } from "./SingleTagField.vue?vue&type=template&id=79ab08d3"
import script from "./SingleTagField.vue?vue&type=script&lang=js"
export * from "./SingleTagField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__